module.exports = __webpack_public_path__ + "img/PRB_LOGO_2c_RGB.df5a7879.png";